module.exports = __webpack_public_path__ + "assets/frutta.64a65d25.svg";